import { TI, Trans } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { LockIcon } from '@treams/treams-icons';
import { EvaluationSubmissionResult } from '@treams/treams-network';
import { tokens } from '@treams/treams-ui';

const PrivateAnswer = styled.div`
	display: flex;
	flex-direction: row;
	gap: ${tokens.gap.list}px;
	color: ${tokens.text.secondary};

	svg {
		opacity: 0.8;
		color: ${tokens.icon.secondary};
	}
`;

export default function PrivateAnswerDisplay({ result }: { result: EvaluationSubmissionResult }) {
	const {
		user: { firstName },
	} = result;

	return (
		<PrivateAnswer>
			<Box size={24} flexShrink={0} flexGrow={0}>
				<LockIcon />
			</Box>
			<p>
				<Trans i18nKey="evaluation.privateAnswer">
					Het bericht van <strong>{{ firstName } as TI}</strong> is zichtbaar als jullie beiden
					jullie antwoord hebben gedeeld.
				</Trans>
			</p>
		</PrivateAnswer>
	);
}
